import { DataBean } from "../DataBean";

export class LaboralPosition extends DataBean {

    public async getLaboralPositionCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "java.util.List_getLaboralPositionCatalogPorPropiedades_java.util.Map_Number",
            [properties, maxRows]
        );
    }

    public async getLaboralPositionRender(page: number, rows: number, props: Record<string, any>): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "com.advantage.shared.Report_getLaboralPositionRender_Number_Number_java.util.Map",
            [page, rows, props]
        );
    }

    public async deleteLaboralPosition(idlaboralposition: number): Promise<any> {
        return this.getCustomService("PayRollERP", "boolean_deleteLaboralPosition_Number", [idlaboralposition]);
    }

    public async updateLaboralPosition(bean: any): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "com.orange.people.payroll.bean.LaboralPosition_updateLaboralPosition_com.orange.people.payroll.bean.LaboralPosition",
            [
                {
                    DataBeanProperties: bean,
                    DataBeanName: "com.orange.people.payroll.bean.LaboralPosition",
                },
            ]
        );
    }

}
